import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaylist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlaylist"><Path d="M21.998 4H19.998V14.4714C19.3908 14.1668 18.6981 14 17.998 14C15.9674 14 13.998 15.404 13.998 17.5C13.998 19.596 15.9674 21 17.998 21C20.0287 21 21.998 19.596 21.998 17.5V4Z" fill="currentColor"/><Path d="M2 5V7H17V5H2Z" fill="currentColor"/><Path d="M2 11V13H12V11H2Z" fill="currentColor"/><Path d="M2 17V19H10V17H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlaylist;
